export type ValidationStatus = 'PENDING' | 'APPROVED' | 'DENIED';
export type ValidationDocumentType = 'AGREEMENT' | 'W8BEN' | 'W9';
export interface ValidationReasonGroup { documentType: ValidationDocumentType; reasons: string[] }

export const validationStatusStyles: Record<ValidationStatus, { icon: string; label: string; className: string; badgeTone: 'success' | 'pending' | 'rejected' }> = {
  PENDING: { icon: '⏳', label: 'Reviewing your documents...', className: 'pending', badgeTone: 'pending' },
  APPROVED: { icon: '✓', label: 'Approved', className: 'approved', badgeTone: 'success' },
  DENIED: { icon: '✕', label: 'Denied', className: 'denied', badgeTone: 'rejected' },
};

const HEADINGS: Record<ValidationDocumentType, string> = { AGREEMENT: 'Agreement', W8BEN: 'W-8BEN', W9: 'W-9' };
const ORDER: ValidationDocumentType[] = ['AGREEMENT', 'W8BEN', 'W9'];

export function DocumentValidationPanel({ status, reasons = [], compact = false, documentType }: { status: ValidationStatus; reasons?: ValidationReasonGroup[] | string[]; compact?: boolean; documentType?: ValidationDocumentType }) {
  const style = validationStatusStyles[status];
  const groups: ValidationReasonGroup[] = reasons.length > 0 && typeof reasons[0] === 'string'
    ? [{ documentType: documentType ?? 'AGREEMENT', reasons: reasons as string[] }]
    : reasons as ValidationReasonGroup[];
  const ordered = [...groups].sort((a, b) => ORDER.indexOf(a.documentType) - ORDER.indexOf(b.documentType));
  return <section className={`document-validation-panel ${style.className}${compact ? ' compact' : ''}`} aria-live="polite">
    <div className="document-validation-status"><span className="document-validation-icon" aria-hidden="true">{style.icon}</span><strong>{status === 'DENIED' ? 'Current Status: Denied' : style.label}</strong></div>
    {status === 'DENIED' && ordered.map((group) => <div className="document-validation-group" key={group.documentType}>
      <h3>{HEADINGS[group.documentType]}</h3>
      <ul>{group.reasons.map((reason, index) => <li key={`${group.documentType}-${index}`}>{reason}</li>)}</ul>
    </div>)}
  </section>;
}
